<template>
  <div>
    <v-card-text>
      <v-row>
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-skeleton-loader
                :loading="loading"
                height="94"
                type="list-item-two-line">
                <v-list-item-title
                  class="title"> {{last_name}} {{name}}
                </v-list-item-title>
                <v-list-item-subtitle>{{email}}</v-list-item-subtitle>

              </v-skeleton-loader>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <v-skeleton-loader
            :loading="loading"
            height="94"
            type="list-item-two-line">
          <v-text-field
            v-model="last_name"
            :label="surNameLabel"
            :error-messages="lastNameValidate"
            :error="lastName_error"
            required>
          </v-text-field>
          </v-skeleton-loader>
        </v-col>
        <v-col cols="12" md="4">
          <v-skeleton-loader
            :loading="loading"
            height="94"
            type="list-item-two-line">
            <v-text-field
              v-model="name"
              :label="nameLabel"
              :error-messages="nameValidate"
              :error="name_error"
              required>
            </v-text-field>
          </v-skeleton-loader>
        </v-col>
        <v-col cols="12" md="4">
          <v-skeleton-loader
            :loading="loading"
            height="94"
            type="list-item-two-line">
          <v-text-field
              v-model="middle_name"
              :error-messages="middleNameValidate"
              :error="middleName_error"
              :label="patronymicLabel" required>
            </v-text-field>
          </v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols='12'>
          <v-skeleton-loader
            :loading="loading"
            height="94"
            type="list-item-two-line">
          <v-autocomplete
            v-model="currentOrganization"
            :items="fullOrganizationArray"
            item-text="name"
            item-value="id"
            :label="scienceOrganizationLabel"
            prepend-icon="mdi-city"
          ></v-autocomplete>
          </v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row>
        <v-col  cols="12" lg="4">
          <v-skeleton-loader
            :loading="loading"
            height="94"
            type="list-item-two-line">
            <v-text-field
              v-model="phone"
              :label="phoneLabel"
              required
              prepend-icon="mdi-phone"></v-text-field>
          </v-skeleton-loader>
        </v-col>
        <v-col cols="12" lg="4">
          <v-skeleton-loader
            :loading="loading"
            height="94"
            type="list-item-two-line">
            <v-autocomplete
              v-model="currentDegree"
              :items="fullDegreeArray"
              item-text="title"
              item-value="id"
              :label='scienceDegreeLabel'
              prepend-icon="mdi-badge-account-outline">
            </v-autocomplete>
          </v-skeleton-loader>
        </v-col>
        <v-col cols="12" lg="4">
          <v-skeleton-loader
            :loading="loading"
            height="94"
            type="list-item-two-line">
            <v-autocomplete
              v-model="currentOrgPosition"
              :items="fullOrgPosinions"
              item-text="title"
              item-value="id"
              label='Должность'
              prepend-icon="mdi-badge-account-outline">
            </v-autocomplete>
          </v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" lg="6">
          <div class="d-flex " style="height:40px; margin-top:10px;">
            <h1 class="switch__current-lang"  x-snall style=" padding-top: 19px;">Пол: Мужской</h1>
            <v-switch  style="color:white;" v-model="is_female" label="Женский"></v-switch>
          </div>
        </v-col>
        <v-col cols="12" lg="6">
          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px">
            <template v-slot:activator="{ on }">
              <v-skeleton-loader

                :loading="loading"
                height="94"
                type="list-item-two-line">
                <v-text-field

                  v-model="computedDate"
                  :label="birthDayLabel"
                  :hint="hint"
                  persistent-hint
                  prepend-icon="mdi-calendar"
                  readonly
                  v-on="on"
                ></v-text-field>
              </v-skeleton-loader>
            </template>
            <v-date-picker 
              v-model="new_date" 
              no-title 
              @input="menu2 = false"
              locale='ru-RU'
              first-day-of-week=1
              scrollable
              min="1925-01-01"
              max="2015-12-31"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-btn
        :color="buttonColor"
        dark
        outlined
        label
        class="mr-4 ml-2"
        :loading="loaded"
        @click="save_btn"
      >обновить личные данные</v-btn>
    </v-card-actions>

  </div>
</template>
<script>
import { validationMixin } from 'vuelidate';
import { required, maxLength, email } from 'vuelidate/lib/validators';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { parserDate, parserString } from '../../helpers/parserDate';

export default {
  mounted() {
    this.uploadDataUser();
  },
  name: 'personalDataBase',
  mixins: [validationMixin],
  validations: {
    name: { required, maxLength: maxLength(10) },
    email: { required, email },
    select: { required },
    checkbox: {
      checked(val) {
        return val;
      },
    },
  },
  data: () => ({

    title: 'This will be the title',
    boilerplate: true,
    loading: false,
    name: '',
    middle_name: '',
    loginChecked: true,
    last_name: '',
    name_error: false,
    lastName_error: false,
    middleName_error: false,
    email: '',
    phone: '',
    model: null,
    academic_rank: null,
    currentDegree: null,
    currentOrgPosition: null,
    is_female: false,
    currentOrganization: null,
    new_date: null,
    // date: new Date().toISOString().substr(0, 10),
    menu2: false,
    head_info: '',
    rules: {
      required: (value) => !!value || 'Required.',
      min: (v) => v.length >= 8 || 'Min 8 characters',
    },
    edit: false,
    fullDegreeArray: null,
    fullOrgPosinions: null, 
    fullOrganizationArray: [],
    loaded: false,
    reg_count: 0,
    buttonColor: '#4dbee1',

  }),
  components: {
  },
  watch: {
    file(val) {
      if (val && typeof val === 'object') {
        this.validateFile(val) 
      }
    },
  },
  computed: {
    ...mapGetters([
      'GETTERS_LOGIN',
      'GETTERS_ORGS_ALPHA',
    ]),
    
    lastNameValidate() {
      return /[^а-яА-ЯёЁ\-]/.test(this.last_name) ? 'только кириллица' : null
    },

    nameValidate() {
      return /[^а-яА-ЯёЁ\-]/.test(this.name) ? 'только кириллица' : null
    },

    middleNameValidate() {
      return /[^а-яА-ЯёЁ\-]/.test(this.middle_name) ? 'только кириллица' : null
    },

    checkboxErrors() {
      const errors = [];
      if (!this.$v.checkbox.$dirty) return errors;
      return errors;
    },
    computedDate() {
      return this.formatDate(this.new_date);
    },
    surNameLabel() {
      return 'Фамилия';
    },
    scienceOrganizationLabel() {
      return 'Научная организация';
    },
    nameLabel() {
      return 'Имя';
    },
    patronymicLabel() {
      return 'Отчество';
    },
    hint() {
      return 'дд.мм.гггг';
    },
    birthDayLabel() {
      return 'Дата рождения'
    },
    phoneLabel() {
      return 'Телефон'
    },
    scienceRankLabel() {
      return 'Научное звание'
    },
    scienceDegreeLabel() {
      return 'Научная степень'
    },
    selectErrors() {
      const errors = [];
      if (!this.$v.select.$dirty) return errors;
      return errors;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      return errors;
    },

  },
  created() {
    this.loading = true;
  },

  methods: {
    ...mapActions([
      'UPDATE_INDIVIDUAL',
      'GET_ACADEMIC_DEGREE',
      'GET_ORG_POSITION_LIST',
      'GET_PERSONAL_DATA',
      'logged',
      'FILE_SEND',
      'ADD_THESIS_FILE',
      'CHANGE_REGISTRATION',
      'MAKE_INVITE',
      'MAKE_SERT'
    ]),
    ...mapMutations([
      'UPDATE_OVERLAY',
    ]),


    async uploadDataUser() {
      try {
        this.loading =true;
        await this.logged({ token: localStorage.token });
        const degree = await this.GET_ACADEMIC_DEGREE();
        const orgs_positions = await this.GET_ORG_POSITION_LIST();

        this.fullOrganizationArray = this.GETTERS_ORGS_ALPHA;
        this.fullDegreeArray = degree.data;
        this.fullOrgPosinions = orgs_positions.data;


        if (this.GETTERS_LOGIN) {
          this.edit = true;
          const data = await this.GET_PERSONAL_DATA();
          this.email = data.username;
          this.last_name = data.profiles[0].individual.last_name;
          this.phone = data.profiles[0].individual.phone_number;
          this.name = data.profiles[0].individual.first_name;
          this.middle_name = data.profiles[0].individual.middle_name || '';
          this.currentDegree = data.profiles[0].individual.academic_degree;
          this.currentOrgPosition = data.profiles[0].individual.org_position;
          this.is_female = data.profiles[0].individual.is_female;
          this.currentOrganization = data.profiles[0].individual.organization;
          const currentDate = data.profiles[0].individual.birth_date
            && parserString(data.profiles[0].individual.birth_date);
          this.new_date = currentDate || '';
        }
        this.loading = false;
      } catch (ex) {
        this.loginChecked = false;
        console.log('ex ---> ', ex);
      }
    },

    get_params() {
      return {
        id: this.GETTERS_LOGIN,
        first_name: this.name,
        last_name: this.last_name,
        middle_name: this.middle_name,
        birth_date: parserDate(this.new_date),
        phone_number: this.phone,
        academic_degree: this.currentDegree,
        org_position: this.currentOrgPosition,
        organization: this.currentOrganization,
        is_female: this.is_female,
      };
    },

    async save_btn() {
      const reg1 = /[^а-яА-ЯёЁ\-]/g; 
      reg1.test(this.last_name) || this.last_name.length === 0 ? this.lastName_error = true : this.lastName_error = false
      reg1.test(this.name) || this.name.length === 0 ? this.name_error = true : this.name_error = false
      reg1.test(this.middle_name) ? this.middleName_error = true : this.middleName_error = false

      if (this.lastName_error || this.name_error ||  this.middleName_error) {
        this.buttonColor = '#DC5959'
        this.loaded = false
        return
      }
      
      this.boilerplate = true;
      this.loaded = true;

      await this.UPDATE_INDIVIDUAL(this.get_params())
        .then((res) => {
          if (res.status === 200) this.$messageHelper('Данные сохранены', 'success', 3000);
          this.loaded = false;
          this.buttonColor = '#656565';
        })
        .catch((e) => {
          this.dialog = true;
          this.loaded = false;
          this.head_info = 'ошибка';
          this.info = `${e}`;
          this.$messageHelper(`${e}`, 'error', 3000);
        });
    },

    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${day}.${month}.${year}`;
    },
  }
};
</script>
<style lang="scss" scoped>
  .description-upload-photo{
    display: none;
    position: absolute;
    background: black;
    color: white;
    opacity: 0.65;
    top:45px;
  }
  .avatar:hover .description-upload-photo{
    display: block;
  }
  .upload{
    opacity: 0;
  }
  .description-photo{
    top:-20px;
  }
  input[type=file] {
    opacity: 0;
    cursor: pointer;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
  .content-personal{
    -webkit-box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    border-width: 0;
    -webkit-transition: all .2s;
    transition: all .2s;
    background-color: #fff;
    border-radius: 13px!important;
}
.theme--light.v-application {
    background: rgb(248, 248, 248) !important;
    color: rgba(0, 0, 0, 0.87);
}

@media screen and (max-width:767px) {
  .content-personal {
    max-width: 90% !important;
  }
  .content-personal__header {
    flex-direction: column;
  }
}
</style>
